// extracted by mini-css-extract-plugin
module.exports = {"svg":"styles_svg__YNrep"};